export enum AnalyticsRoles {
  VIEWER = 'roles.analyticsViewer',
  SELF_SERVE_ANALYST = 'roles.analyticsSelfServeAnalyst',
}
